import { deleteActivityFormTemplateByFormAndActivity } from "../../_services/activity_form_template.service";

export const deleteActivityFormTemplateByFormAndActivityEvent = async (form, activity) => {
    return await deleteActivityFormTemplateByFormAndActivity(form, activity);
}